"use client";
import {
  CORPORATE_DETAIL_PATH,
  JOB_INFORMATION_DETAIL_PATH,
} from "@/services/constants/routerPath";
import {
  Box,
  Card,
  HStack,
  Show,
  SimpleGrid,
  Stack,
  Text,
} from "@chakra-ui/react";
import { get } from "lodash";
import Link from "next/link";
import { Autoplay, Grid, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
const JobBasicAdsSlider = ({ data }) => {
  return (
    <Stack w="full" gap={6}>
      <Swiper
        style={{ width: "100%" }}
        grid={{ rows: 2, fill: "row" }}
        slidesPerView={1}
        spaceBetween={4}
        modules={[Autoplay, Grid, Navigation]}
        loop={true}
        loopAddBlankSlides={false}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        // navigation={{ enabled: true }}
        breakpoints={{
          768: {
            slidesPerView: 1,
            // navigation: { enabled: true },
          },
          1280: {
            slidesPerView: 1,
            // navigation: { enabled: true },
          },
        }}
      >
        {data.map((categoryJobItem, index) => {
          return (
            <SwiperSlide key={index} h="full">
              <SimpleGrid
                columns={{ base: 2, sm: 2, md: 3, lg: 4, xl: 5 }}
                rowGap={{ base: 1, md: 2, lg: 4 }}
                columnGap={{ base: 1, md: 2, lg: 4 }}
              >
                {categoryJobItem.map((adsJob) => {
                  const { job, photos } = adsJob;
                  return (
                    get(job, "_id") && (
                      <Card key={get(job, "_id")} as={Stack} px={2} py={4}>
                        <Show>
                          <HStack spacing={2} justify="space-between">
                            <Link
                              href={
                                CORPORATE_DETAIL_PATH +
                                get(job, "corporate._id")
                              }
                              fontSize="xs"
                              fontWeight="semibold"
                              noOfLines={1}
                              title={get(job, "companyName")}
                            >
                              {get(job, "companyName")}
                            </Link>
                            <Text
                              fontSize="xs"
                              color="secondary"
                              noOfLines={1}
                              title={get(job, "region.ko")}
                            >
                              {get(job, "region.ko")}
                            </Text>
                          </HStack>
                          <Box flexShrink={0}>
                            <Box
                              h={50}
                              w="full"
                              bgImage={
                                get(photos?.[0], "url") ??
                                get(job, "recruitmentNotice[0].url") ??
                                get(job, "corporate.logo.url")
                              }
                              bgSize="cover"
                              bgPos="center"
                              alt="logo"
                            />
                          </Box>
                          <Stack
                            flexGrow={1}
                            h="full"
                            justify="space-between"
                            gap={0}
                          >
                            <Link
                              w="fit-content, "
                              href={
                                JOB_INFORMATION_DETAIL_PATH + get(job, "_id")
                              }
                              fontWeight="semibold"
                              noOfLines={2}
                              title={get(job, "recruitmentName")}
                            >
                              {get(job, "recruitmentName")}
                            </Link>
                            <Text
                              fontSize="xs"
                              noOfLines={2}
                              color="placeholder"
                            >
                              {get(job, "positionInfo.ko")}
                            </Text>
                          </Stack>
                        </Show>
                      </Card>
                    )
                  );
                })}
              </SimpleGrid>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </Stack>
  );
};

export default JobBasicAdsSlider;
